<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新宴席管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-add"
                   @click="openImport">导入</el-button>
      </div>
      <el-table :data="table"
                stripe
                border>
        <el-table-column prop="id"
                         label="ID"
                         width="80"></el-table-column>
        <el-table-column prop="display_name"
                         label="名称"
                         min-width="140">
          <template slot-scope="scope">
            <span class="link-text"
                  @click="onDownSourceFile(scope.row.id)">{{ scope.row.display_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发起者"
                         width="140">
          <template slot-scope="scope">
            {{ scope.row.admin_name }} ({{ scope.row.admin_id }})
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="上传时间"
                         min-width="160"></el-table-column>
        <el-table-column label="任务进度"
                         min-width="180">
          <template slot-scope="scope">
            <sj-progress :text-inside="true"
                         :stroke-width="18"
                         :status="taskBatchStatus(scope.row)"
                         :percentages="taskBatchPercentage(scope.row)">
            </sj-progress>
            成功:{{ scope.row.success_count }} 错误:{{ scope.row.error_count }}
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         width="100">
          <template slot-scope="scope">
            {{ batchStatusLabel(scope.row.status) }}
            <span v-if="scope.row.status === -2 && scope.row.error_message">{{ scope.row.error_message }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="120">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       v-if="[3, -1, -2, -3, -4].includes(scope.row.status) && scope.row.error_count > 0"
                       @click="onDownErrorFile(scope.row.id)">下载错误行</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <el-dialog title="导入宴席任务"
               :visible.sync="importVisible"
               width="640px"
               @closed="resetImport">
      <el-form label-width="96px"
               size="medium">
        <el-form-item label="客户">
          <remote-select class="width-max"
                         :key="customerid || 'customer-empty'"
                         clearable
                         id-key="number"
                         label-key="name"
                         value-key="id"
                         placeholder="输入客户名称/编号"
                         v-model="customerid"
                         @change="onCustomerChange"
                         :query-request="getCustomerTable"
                         :find-request="getCustomerDetail">
          </remote-select>
        </el-form-item>
        <el-form-item label="项目">
          <remote-select class="width-max"
                         clearable
                         id-key="number"
                         label-key="name"
                         value-key="id"
                         placeholder="输入项目名称/编号"
                         v-model="projectid"
                         :disabled="!customerid"
                         @change="onProjectChange"
                         :query-request="queryProject"
                         :find-request="getProjectDetail">
          </remote-select>
        </el-form-item>
        <el-form-item label="批次">
          <remote-select class="width-max"
                         clearable
                         id-key="number"
                         label-key="detail"
                         value-key="id"
                         placeholder="输入批次名称/编号"
                         v-model="batchid"
                         :disabled="!projectid"
                         :query-request="queryBatch"
                         :find-request="getBatchDetail">
          </remote-select>
        </el-form-item>
        <el-form-item label="表格">
          <el-upload action=""
                     :auto-upload="false"
                     :limit="1"
                     accept=".xlsx,.xls,.csv"
                     :file-list="fileList"
                     :on-change="onFileChange"
                     :on-remove="onFileRemove">
            <el-button size="small"
                       type="primary">选择表格</el-button>
          </el-upload>
          <el-button size="small"
                     type="text"
                     @click="downloadDemo">下载Demo</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="importVisible = false">取消</el-button>
        <el-button type="primary"
                   :loading="importing"
                   @click="submitImport">开始导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import SjProgress from '@/components/sj-progress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'
import { taskTypes } from '@views/task-batch/task-batch-opts'
import downloadJS from 'downloadjs'
import {banquetImportDemoHeader, banquetImportDemoRows} from '../banquet-task-import-demo'

export default {
  mixins: [table, taskBatchMixins],
  components: {SjProgress},
  data () {
    return {
      importVisible: false,
      customerid: '',
      projectid: '',
      batchid: '',
      fileList: [],
      importFile: null,
      importing: false,
      search: {
        task_type: taskTypes.BATCH_BANQUET_TASK_IMPORT.value,
      },
      searchFieldType: {
        task_type: Number,
      },
    }
  },
  computed: Vuex.mapState({
    status: state => state.taskBatch.status,
  }),
  methods: {
    ...request.map([
      'getCustomerTable',
      'getCustomerDetail',
      'getProjectTable',
      'getProjectDetail',
      'getBatchTable',
      'getBatchDetail',
    ]),
    getTableData (params) {
      params.task_type = taskTypes.BATCH_BANQUET_TASK_IMPORT.value
      return request.common('queryWaitProcessJobsApi', params)
    },
    openImport () {
      this.resetImport()
      this.importVisible = true
      request.common('banquetTaskImportConfig').then(({data}) => {
        if (data && Number(data.customerid) > 0) {
          this.customerid = String(data.customerid)
        }
      })
    },
    resetImport () {
      this.customerid = ''
      this.projectid = ''
      this.batchid = ''
      this.fileList = []
      this.importFile = null
    },
    queryProject (params) {
      return this.getProjectTable(Object.assign({
        customerid: this.customerid,
      }, params))
    },
    queryBatch (params) {
      return this.getBatchTable(Object.assign({
        customerid: this.customerid,
        projectid: this.projectid,
        per_page: 100,
      }, params))
    },
    onCustomerChange () {
      this.projectid = ''
      this.batchid = ''
    },
    onProjectChange () {
      this.batchid = ''
    },
    onFileChange (file, fileList) {
      this.fileList = fileList.slice(-1)
      this.importFile = file.raw
    },
    downloadDemo () {
      this.$export('宴席任务导入Demo', banquetImportDemoRows(), {
        fileHeader: banquetImportDemoHeader(),
      })
    },
    onFileRemove () {
      this.fileList = []
      this.importFile = null
    },
    submitImport () {
      if (!this.customerid || !this.projectid || !this.batchid) {
        this.$message.error('请选择客户、项目、批次')
        return
      }
      if (!this.importFile) {
        this.$message.error('请选择表格')
        return
      }
      const formData = new FormData()
      formData.append('file', this.importFile)
      formData.append('params', JSON.stringify({
        customerid: Number(this.customerid),
        projectid: Number(this.projectid),
        batchid: Number(this.batchid),
      }))
      this.importing = true
      request.common('banquetTaskImport', formData).then(() => {
        this.importing = false
        this.$message.success('已创建批量任务')
        this.importVisible = false
        this.onRefresh()
      }).catch(() => {
        this.importing = false
      })
    },
    onDownSourceFile (id) {
      downloadJS(request.items.downSourceFile(id))
    },
    batchStatusLabel (value) {
      const found = this.status.find(item => item.value === value)
      return found ? found.label : value
    },
  },
}
</script>

<style lang="scss"
       scoped>
.link-text {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/banquet-task/pages/BanquetTaskBatchTable.vue